//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getChannel } from '@/helpers/channels.js';

export default {
  name: 'HowToUseMidjourney',
  components: {
    HomeBenefits: () => import('@/components/home-page/HomeBenefits.vue'),
    StepItem: () => import('@/components/core/elements/StepItem.vue'),
  },
  props: {
    channelId: {
      type: String,
      required: true,
    },
  },
  computed: {
    currentChannelName() {
      return _.get(getChannel(this, this.channelId), 'headingHtml');
    },
  },
};
